import React, { useEffect } from 'react'
import Product from '../components/Product'
import { products } from '../data'

export default function Favourites() {
  if (!localStorage.getItem('reloadGN')) {
    localStorage.setItem('reloadGN', 'true');
    window.location.reload();
}
  return (
    <>
    <div className="min-h-screen w-full py-12">
      <div className="mxw">
        <div className="w-full h-fit py-4 text-left">
            <p className="text-3xl font-bold">Your Favourites</p>
        </div>
      </div>
      <div className="mxw grid grid-cols-2 gap-2 md:gap-4 mt-6 place-items-center">
        {products?.slice(0,8)?.map(product => (
          <div className="h-full w-full">
            <Product product={product}/>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}
